import { mutator } from 'satcheljs';
import { initializeArchiveMailboxFromSessionData } from '../actions/publicActions';
import Folder from 'owa-service/lib/contract/Folder';
import { ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID } from '../util/folderConstants';
import { getUserConfiguration } from 'owa-session-store';
import getMailboxTable from '../selectors/getMailboxTable';
import { removeMailboxData, onAddSharedFolderSuccess } from '../actions/internalActions';
import MailBoxData from '../store/schema/MailboxData';
import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';

/**
 * Initializes the archive root folder with session data.
 */
mutator(initializeArchiveMailboxFromSessionData, () => {
    // Initialize the archive root folder using the data received in session data such as display name and set it in the store.
    const folder: Folder = {
        DistinguishedFolderId: ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
        DisplayName: getUserConfiguration().SessionSettings.ArchiveDisplayName,
    };

    // update the archive mailbox root and loading state.
    setMailboxData(
        ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
        folder,
        MailboxLoadStateEnum.Uninitialized
    );
});

mutator(onAddSharedFolderSuccess, actionMessage => {
    setMailboxData(
        actionMessage.principalSMTPAddress,
        actionMessage.folder,
        MailboxLoadStateEnum.Uninitialized
    );
});

mutator(removeMailboxData, actionMessage => {
    getMailboxTable().delete(actionMessage.mailboxId);
});

export function setMailboxData(id: string, rootFolder: Folder, loadingState: MailboxLoadStateEnum) {
    const mailbox: MailBoxData = {
        id: id,
        rootFolder: rootFolder,
        loadingState: loadingState,
    };
    getMailboxTable().set(id, mailbox);
}
